const header = {
  state: {
    isShowHeader: true,
    cardCityCode: '',
    cardCityName: ''
  },
  mutations: {
    isShowHeader (header, preload) {
      header.isShowHeader = preload.isShowHeader;
    },
    headerCityChange (header, preload) {
      header.cardCityCode = preload.cardCityCode;
      header.cardCityName = preload.cardCityName;
    }
  },
  actions: {

  }
};

export default header;



// WEBPACK FOOTER //
// ./src/stores/modules/header.js